import { computedFrom, autoinject } from 'aurelia-framework';
import * as moment from 'moment';
import { Router } from 'aurelia-router';
import { Customer, Payment, Account } from '../models/customer';
import { Features } from '../models/features';
import { I18N } from 'aurelia-i18n';
import { BasePage } from '../pages/base-page';
import { EventAggregator } from 'aurelia-event-aggregator';
import { PayrazrService } from './payrazr';
import { State } from './global-state';

@autoinject
export class MessagesService {
	messages = [];
	accounts = [];
	newMessages = 0;
	newMessagesNotificationText: string = '';

	constructor(private payrazrService: PayrazrService, private globalState: State, private router: Router, private i18n: I18N) {
		this.accounts = (globalState.accounts || []).filter(item => {
			let portfolio = this.globalState.business.fetchPortfolioSettings(item.portfolioName);

			return (portfolio && portfolio.hasSettings && portfolio.settings.paymentMethods);
		});
	}

	getMessages() {
		return this.payrazrService.getMessages()
			.then(response => {
				this.messages = [];
				this.newMessages = 0;
				let accountRefIdDic = {};
				this.accounts.forEach((account) => {
					accountRefIdDic[account.name] = account.displayName;
				}, this);
				response.forEach((message) => {
					if (accountRefIdDic[message.customerAccountReferenceId]) {
						message.CustomerAccountReferenceId = accountRefIdDic[message.customerAccountReferenceId];
						this.replaceTokensInMessage(message);
						this.messages.push(message);
						if (!message.readDate) {
							this.newMessages++;
						}
					}
				}, this);
				this.newMessagesNotificationText = this.i18n.i18next.t('youHaveXNewMessage', { defaultValue: `You have ${this.newMessages} new message`, count: this.newMessages }) + (this.newMessages === 1 ? '' : 's');
			})
			.catch((error) => {
				console.error(error);
			});
	}

	replaceTokensInMessage(message) {
		// replace documentlink token
		if (message.message.indexOf('{documentlink}') > 0) {
			message.message = message.message.replace('{documentlink}', '');
			message.hasLink = true;
			message.linkText = this.i18n.i18next.t('seeDocuments', 'See Documents');
		}
	}

	markAsRead(message) {
		let date = moment();
		message.readDate = date;
		this.newMessages--;
		this.payrazrService.markMessageAsRead([message.messageId]);
	}

}
